<script setup>

import StickyGrid from "@/components/common/other/StickyGrid";
import Button from "@/components/common/input/Button";
import CheckBox from "@/components/common/input/CheckBox";
import StaticWidget from "@/components/common/other/StaticWidget";
import StaticTooltip from "@/components/common/other/StaticTooltip";
import StockSearchItem from "@/classes/stock/StockSearchItem";
import DateInput from "@/components/common/input/DateInput"

import {inject, ref} from 'vue'

import {useStore} from 'vuex';

const store = useStore();
const stockSearch = inject('stockSearch');

function handleClearAllFields() {

  stockSearch.value.stockSearchCriteria = new StockSearchItem();
}

</script>

<template class="cmp-browse-warehouse">
  <div class="cmp-browse-warehouse_wrapper">
    <StaticWidget title="Browse Warehouse" height="735">
      <div class="cmp-browse-warehouse_search-area">
        <div class="cmp-browse-warehouse_search-area-icon">
          <i class="fa-regular fa-magnifying-glass" style="color: var(--aqua-blue-definition); font-size: 35px;"></i>
        </div>
        <div class="cmp-browse-warehouse_search-fields">
          <TextInput
              v-model="stockSearch.searchCriteria.skuNumber"
              :clearable="true"
              :width="220"
              :label-top="true"
              label="SKU Number">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.skuName"
              :clearable="true"
              :width="240"
              :label-top="true"
              label="SKU Name">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.skuGroup"
              :clearable="true"
              :width="245"
              :label-top="true"
              label="SKU Group">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.skuComposite"
              :clearable="true"
              :width="240"
              :label-top="true"
              label="Job Ref">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.description"
              :clearable="true"
              :width="280"
              :label-top="true"
              label="Warehouse Ref">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.description"
              :clearable="true"
              :width="280"
              :label-top="true"
              label="Customer Ref">
          </TextInput>
        </div>
        <div class="cmp-browse-warehouse_search-fields">
          <TextInput
              v-model="stockSearch.searchCriteria.skuNumber"
              :clearable="true"
              :width="220"
              :label-top="true"
              label="SO Number">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.skuName"
              :clearable="true"
              :width="240"
              :label-top="true"
              label="Deliver To">
          </TextInput>
          <DateInput
              v-model="stockSearch.searchCriteria.skuGroup"
              :width="245"
              :clearable="true"
              :label-top="true"
              label="Release Date From">
            <el-date-picker></el-date-picker>
          </DateInput>
          <DateInput
              style="margin-left: 12px"
              :width="238"
              v-model="stockSearch.searchCriteria.skuGroup"
              :clearable="true"
              :label-top="true"
              label="Release Date To">
            <el-date-picker></el-date-picker>
          </DateInput>
          <div style="margin: 0 0 0 128px;">
            <CheckBox
                v-model="stockSearch.searchCriteria.zeroQty"
                :label-width="124"
                label="Notification Not Sent">
            </CheckBox>
          </div>
          <div style="margin-left: 195px;">
            <Button text="Search" type="plain"></Button>
          </div>
          <StaticTooltip :icon="false">
            <template #content>
              Clear All
            </template>
            <i class="fa-solid fa-trash-can-list" style="color:#4c4c4c; cursor: pointer; margin-top: 4px;" @click="handleClearAllFields"></i>
          </StaticTooltip>
        </div>
      </div>
      <StaticWidget title="Search Results" height="600">
        <template #right-side>
          <Button text="Refresh" type="toolbar"></Button>
        </template>
        <div class="cmp-browse-warehouse_search-results-wrapper">
          <StickyGrid
              :allowGridMenu="false"
              height="300"
              :page-size="100"
              :selectable="true"
              :row-selection="false"
              v-model:currentPage="store.state.newGridPaginationRange"
              v-model:currentPaginationRange="store.state.newGridCurrentPage"
              :dataSource="store.state.dummyGridData"
              :columns="store.state.dummyGridColumns">
            <template #selectAllRows>
              <CheckBox
                  v-model="stockSearch.searchCriteria.zeroQty">
              </CheckBox>
            </template>
          </StickyGrid>
        </div>
      </StaticWidget>
    </StaticWidget>
  </div>
</template>

<style lang="scss" scoped>

.cmp-browse-warehouse {

  &_search-results-wrapper {
    margin-top: 40px;
  }

  &_search-area {
    position: relative;
    height: 120px;
    gap: 20px;
    width: 1820px;
    background-color: #fcfcfc;
    border-radius: var(--rounded-corners);
    border: 1px solid var(--border-color);
  }

  &_search-area-icon {
    position: absolute;
    top: 40px;
    left: 30px;
    height: 120px;
  }

  &_search-fields {
    display: flex;
    padding-top: 30px;
    margin-left: 100px;
    gap: 20px;
  }

}
</style>
